import { USER_ID_KEY } from 'lib/utils/constants'
import { useLocalStorage } from 'react-use'

const getRandomUserId = () => {
  const characters = 'abcdefghijklmnopqrstuvuxyzABCDEFGHIJKLMNOPQRSTUVUXYZ0123456789'
  let userId = ''
  const userIdLength = 25

  while (userId.length < userIdLength) {
    const character = characters.at(Math.floor(Math.random() * characters.length))
    userId += character
  }

  return userId
}

const useUserId = () => {
  const [userId] = useLocalStorage(USER_ID_KEY, getRandomUserId())
  return userId
}

export default useUserId
